import { useMsal } from "@azure/msal-react";

export interface UserProfile {
    id: string;
    name: string;
    email: string;
    initials: string;
}

/**
 * Hook to get the current user's profile information.
 * Uses the authenticated MSAL account.
 */
export function useCurrentUser(): UserProfile | null {
    const { accounts, instance } = useMsal();

    const account = instance.getActiveAccount() ?? accounts[0];
    if (account) {
        const name = account.name || "User";

        // Extract the most stable immutable ID from the token claims
        const id = (account.idTokenClaims as any)?.oid ||
            (account.idTokenClaims as any)?.sub ||
            account.localAccountId;

        const initials = name
            .split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase()
            .slice(0, 2);

        return {
            id: id,
            name: name,
            email: account.username,
            initials: initials,
        };
    }

    return null;
}
